module.exports = __webpack_public_path__ + "img/Background.406f2f6d.png";